import store from 'store/Store';
import OrderActions from 'actions/OrderActions';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';
import Empty from 'constants/empty';

/**
 * Remove the payment-promo banner once the shopper resolves the condition on the checkout page
 * (e.g. successfully re-applies the previously removed payment-conditional promo). The banner is
 * stashed/consumed only at order init, so an in-page promo apply must clear it explicitly. Lives in
 * its own dependency-light module so `utils/Promos` can clear the banner without importing the heavy
 * `utils/Checkout` module (React + checkout components).
 *
 * @returns {void}
 */
function clearPaymentPromoBanner() {
    Storage.session.removeItem(LOCAL_STORAGE.PAYMENT_PROMO_BANNER);
    store.dispatch(OrderActions.setPaymentPromoBanner(Empty.Array));
}

export { clearPaymentPromoBanner };
